export default __webpack_public_path__ + "e4ca7dd279d711cbaa901a8452218787.svg";